const STORAGE_KEY = 'tleo_presupuestos';
const COUNTER_KEY = 'tleo_presupuesto_num';

export function getNextNumber() {
  const n = parseInt(localStorage.getItem(COUNTER_KEY) || '1000', 10);
  return n + 1;
}

export function savePresupuesto(data) {
  const list = getPresupuestos();
  list.push({ ...data, savedAt: new Date().toISOString() });
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  localStorage.setItem(COUNTER_KEY, String(data.numPresupuesto));
}

export function getPresupuestos() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function clearAll() {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(COUNTER_KEY);
}
